import MapOutlined from "@mui/icons-material/MapOutlined";
import TableRowsOutlined from "@mui/icons-material/TableRowsOutlined";
import { Box, Grid, IconButton, Tooltip } from "@mui/material";
import ExplorerGrid, { useExplorerGrid } from "common/ExplorerGrid";
import { Can } from "context/permissionContenxt";
import PageNotFound from "pages/PageNotFound";
import useToolbarProps from "qubCommon/ExplorerToolbar/useToolbarProps";
import { TextInput } from "qubCommon/Inputs";
import { useState } from "react";
import ApartmentsMapView from "./Apartments/ApartmentsMapView";

const ApartmentsExplorer = () => {
  const [isMapView, setIsMapView] = useState(false);
  const { status, critParams, ...toolbarRest } = useToolbarProps({
    webPageKey: "MhdApartments-Expl",
    hideAddNew: true,
  });

  const { explParams, ...explorerRest } = useExplorerGrid({
    explorerDataKey: "MhdApartments-Expl",
    xlsxName: "Διαμερίσματα ΜΗΔ",
    navUrl: "",
    status,
    onSelect: () => {},
    onPopUp: () => {},
  });

  return (
    <>
      <Can I="View" a="MHD_Apartments">
        <div
          style={{
            margin: 20,
            padding: 20,
            borderRadius: 8,
            backgroundColor: "#f3f3f3",
          }}
        >
          <ExplorerGrid
            explParams={explParams}
            title="MhdApartments"
            breadcrumbs={[
              { name: "apartments", path: "govnr/apartments-explorer" },
            ]}
            hideAscendingRowNumber
            autoRowHeights
            buttons={
              <Box boxShadow={2} sx={{ borderRadius: 50 }}>
                <Tooltip
                  title={isMapView ? "Προβολή πίνακα" : "Προβολή χάρτη"}
                >
                  <IconButton
                    aria-label={
                      isMapView ? "Προβολή πίνακα" : "Προβολή χάρτη"
                    }
                    aria-pressed={isMapView}
                    onClick={() => setIsMapView((currentView) => !currentView)}
                  >
                    {isMapView ? <TableRowsOutlined /> : <MapOutlined />}
                  </IconButton>
                </Tooltip>
              </Box>
            }
            alternativeView={isMapView ? <ApartmentsMapView /> : null}
            {...explorerRest}
            {...toolbarRest}
          >
            <Grid item xs={12} md={6} lg={4}>
              <TextInput
                id="Search"
                name="searchFieldValue"
                label={"Αναζήτηση"}
                placeholder={"Αναζήτηση"}
                defaultValue={critParams?.searchFieldValue ?? ""}
              />
            </Grid>
          </ExplorerGrid>
        </div>
      </Can>
      <Can not I="View" a="MHD_Apartments">
        <PageNotFound />
      </Can>
    </>
  );
};
export default ApartmentsExplorer;
